/** Лимит длины заголовка в карточке вложения (ширина бабла в чате), с учётом символа «…». */
export const ATTACHMENT_CARD_TITLE_MAX_LEN = 30;

const ELLIPSIS = '\u2026';

export function clampAttachmentCardTitle(full: string): string {
  const t = full.trim();
  if (t.length <= ATTACHMENT_CARD_TITLE_MAX_LEN) return t;
  const headLen = ATTACHMENT_CARD_TITLE_MAX_LEN - ELLIPSIS.length;
  return headLen <= 0 ? ELLIPSIS : `${t.slice(0, headLen)}${ELLIPSIS}`;
}
